import { DrawablyCard } from 'drawably/react';
import { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { X } from 'lucide-react';

const PopUpMax = ({ title, content, onClose }) => {
    const closeButtonRef = useRef(null);
    const sanitizedContent = useMemo(() => {
        return typeof content === 'string' ? DOMPurify.sanitize(content) : '';
    }, [content]);

    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        const previousActiveElement = document.activeElement;

        document.body.style.overflow = 'hidden';
        closeButtonRef.current?.focus();

        const handleEscape = (event) => {
            if (event.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleEscape);

        const widget = document.getElementById('dl-widget');
        const widgetScript = document.createElement('script');
        if (
            widget &&
            !document.querySelector('script[src="https://widget.droplabs.pl/widget.js"]')
        ) {
            widgetScript.src = 'https://widget.droplabs.pl/widget.js';
            widgetScript.type = 'text/javascript';
            document.body.appendChild(widgetScript);
        }

        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', handleEscape);
            widgetScript.remove();
            previousActiveElement?.focus?.();
        };
    }, [onClose]);

    return (
        <div className="anikino__popup-max-overlay" role="presentation">
            <DrawablyCard
                className="anikino__popup-max"
                role="dialog"
                roughness={1.4}
                boil={0.1}
                width={2.5}
                aria-modal="true"
                aria-labelledby={title ? 'anikino-popup-max-title' : undefined}
            >
                <button
                    ref={closeButtonRef}
                    className="anikino__popup-max-close"
                    type="button"
                    aria-label="Zamknij popup"
                    onClick={onClose}
                >
                    <X size={24} aria-hidden="true" />
                </button>
                {title && <h2 id="anikino-popup-max-title">{title}</h2>}
                <div className="anikino__popup-max-content">
                    {typeof content === 'string' ? (
                        <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
                    ) : (
                        content
                    )}
                </div>
            </DrawablyCard>
        </div>
    );
};

PopUpMax.propTypes = {
    title: PropTypes.node,
    content: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default PopUpMax;
